<template>
	<div class="experience-stepper">
		<div class="step first-step">
			<div class="current" v-if="currentStep === 1">
				<div class="icon" v-html="svgStore.get('iconCalendar')"></div>
				<div class="info">{{ getString("date") }}</div>
			</div>
			<div class="done" v-if="currentStep > 1" @click="backToStep(1)">
				<div class="info">{{ formattedChosenDate }}</div>
			</div>
		</div>
		<div class="step second-step">
			<div class="undone" v-if="currentStep < 2">
				<div class="icon" v-html="svgStore.get('iconClock')"></div>
			</div>
			<div class="current" v-if="currentStep === 2">
				<div class="icon" v-html="svgStore.get('iconClock')"></div>
				<div class="info">{{ getString("time") }}</div>
			</div>
			<div class="done" v-if="currentStep > 2" @click="backToStep(2)">
				<div class="info">{{ reservationsStore.chosenTime.time }}</div>
			</div>
		</div>
		<div class="step third-step">
			<div class="undone" v-if="currentStep < 3">
				<div class="icon" v-html="svgStore.get('iconUser')"></div>
			</div>
			<div class="current" v-if="currentStep === 3">
				<div class="icon" v-html="svgStore.get('iconUser')"></div>
				<div class="info">{{ getString("people") }}</div>
			</div>
			<div class="done" v-if="currentStep > 3" @click="backToStep(3)">
				<div class="info">{{ reservationsStore.chosenPeople > 1 ? getString("people_num", [reservationsStore.chosenPeople]) : getString("one_person") }}</div>
			</div>
		</div>
		<div class="step fourth-step">
			<div class="undone" v-if="currentStep < 4">
				<div class="icon" v-html="svgStore.get('iconInfo')"></div>
			</div>
			<div class="current" v-if="currentStep === 4">
				<div class="icon" v-html="svgStore.get('iconInfo')"></div>
				<div class="info">{{ getString("info") }}</div>
			</div>
			<div class="done" v-if="currentStep > 4">
				<div class="icon" v-html="svgStore.get('iconV')"></div>
			</div>
		</div>
	</div>
    <div class="current-step-highlight">
        <div class="highlight-line"></div>
        <div class="highlight-content">
			<div class="loader" v-if="reservationsStore.loadingAvailabilities">
				<AppLoader color="var(--theme-txt2-color)" :size="20" />
			</div>
            <div class="icon" v-html="highlightIcon" v-else></div>
            <div class="title">{{ highlightTitle }}</div>
        </div>
        <div class="highlight-line"></div>
    </div>
</template>

<script>
import {useLanguageStore, useSvgStore} from "@/shared/stores";
import {useReservationsStore} from "@/book/stores";
import AppLoader from "@/shared/components/AppLoader.vue";
import {useMenusStore} from "@/new-menu/stores";

export default {
	components: {AppLoader},
	setup() {
		let svgStore = useSvgStore();
		let languageStore = useLanguageStore();
        const reservationsStore = useReservationsStore();
		const menusStore = useMenusStore();
		return {svgStore, getString: languageStore.getString, languageStore, reservationsStore,menusStore};
	},
	name: "ExperienceStepper",
	props: {
		currentStep: {
			type: Number,
			required: true
		}
	},
    computed: {
        formattedChosenDate() {
            let date = this.reservationsStore.chosenDate;
            return date ? date.toLocaleDateString([this.languageStore.lang || 'en-US'], {day: 'numeric', month: 'short'}) : '';
		},
        highlightTitle() {
			switch (this.currentStep) {
				case 1:
					return this.getString("choose_date");
				case 2:
					return this.getString("choose_time");
				case 3:
					return this.getString("num_of_people");
				case 4:
					return this.getString("confirm_reservation");
				case 5:
					return this.getString("reservation_done");
			}
		},
        highlightIcon() {
			switch (this.currentStep) {
				case 1:
					return this.svgStore.get('iconCalendar');
				case 2:
					return this.svgStore.get('iconClock');
				case 3:
					return this.svgStore.get('iconUser');
				case 4:
					return this.svgStore.get('iconInfo');
				case 5:
					return this.svgStore.get('iconV');
			}
        }
    },
	methods: {
		backToStep(step) {
			if(step <= 1) {
				this.reservationsStore.chosenDate = null;
			}
			if(step <= 2) {
				this.reservationsStore.chosenTime.time = null;
				this.reservationsStore.chosenTime.slotId = null;
				this.reservationsStore.chosenTime.maxPeople = null;
			}
			if(step <= 3) {
				this.reservationsStore.chosenPeople = null;
			}
			this.reservationsStore.currentStep = step;
		}
	}
}
</script>

<style scoped lang="scss">
.experience-stepper {
	display: flex;
	justify-content: space-between;
	width: 100%;
	background-color: var(--theme-bg2-color);
	border-radius: var(--rounded-corner);

	.step {
		display: flex;
		flex-direction: column;
		align-items: center;
		width: 25%;

		.undone, .current, .done {
			position: relative;
			display: flex;
			align-items: center;
			justify-content: center;
			gap: var(--padding-horizontal-s);
			padding: var(--padding-vertical) 0;
			width: 100%;
			height: 100%;

			@media (max-width: 500px) {
				gap: 6px;
			}
		}

		.current, .done {
			background-color: var(--business-color);
		}

		&:first-child .current, &:first-child .done {
			border-top-left-radius: var(--rounded-corner);
			border-bottom-left-radius: var(--rounded-corner);
		}

		&:last-child .current, &:last-child .done {
			border-top-right-radius: var(--rounded-corner);
			border-bottom-right-radius: var(--rounded-corner);
		}

		.current {

			.info {
				max-width: 50px;
				@include truncateString();
			}

			&:after {
				content: '';
				position: absolute;
				top: 50%;
				right: -9px;
				width: 30px;
				height: calc(100% / sqrt(2));
				transform: rotate(-45deg);
				transform-origin: 0 0;
				background-color: var(--business-color);
				border-bottom-right-radius: var(--rounded-corner-s);
			}
		}

		.undone {
			--arrow-height: 12px;

			&:after {
				content: '';
				position: absolute;
				top: calc(50% - var(--arrow-height) + 2px);
				right: -9px;
				width: 3px;
				height: var(--arrow-height);
				transform: rotate(-35deg);
				background-color: var(--business-color);
				border-bottom-right-radius: 1px;
				border-top-right-radius: 2px;
				border-top-left-radius: 2px;
			}

			&:before {
				content: '';
				position: absolute;
				top: calc(50% - 2px);
				right: -9px;
				width: 3px;
				height: var(--arrow-height);
				transform: rotate(35deg);
				background-color: var(--business-color);
				border-top-right-radius: 1px;
				border-bottom-right-radius: 2px;
				border-bottom-left-radius: 2px;
			}
		}

		.done {
			cursor: pointer;

			.info {
				max-width: 70px;
				@include truncateString();
			}

			&:after {
				content: '';
				position: absolute;
				top: 5px;
				right: -3px;
				width: 3px;
				height: calc(100% - 10px);
				background-color: var(--theme-bg2-color);
				z-index: 3;
				border-radius: 1px;
			}
		}

		&.fourth-step .current:after {
			display: none;
		}

		&.fourth-step .undone {
			&:after, &:before {
				display: none;
			}
		}

		&.fourth-step .done {
			cursor: default;

			&:after {
				display: none;
			}
		}

		.icon {
			display: flex;
			align-items: center;
			justify-content: center;

			&:deep(svg) {
				width: 18px;
				height: 18px;

				.fill {
					fill: var(--business-text-color);
				}

				.stroke {
					stroke: var(--business-text-color);
				}
			}
		}

		.undone {
			.icon {
				:deep(svg) {
					.fill {
						fill: var(--theme-txt2-color);
					}

					.stroke {
						stroke: var(--theme-txt2-color);
					}
				}
			}
		}

		.info {
			font-size: var(--font-size);
			font-weight: 500;
			color: var(--business-text-color);
			text-transform: capitalize;
			z-index: 10;
		}

	}
}
.current-step-highlight {
    display: flex;
    flex-direction: column;
	justify-content: center;
	align-items: center;
    margin-top: var(--padding-vertical);
    gap: var(--padding-vertical);

	.highlight-line {
        width: 100%;
		height: 1px;
		background-color: var(--theme-txt2-color);
	}

	.highlight-content {
        display: flex;
        align-items: center;
        gap: var(--padding-horizontal-s);

        .icon {
			display: flex;
			align-items: center;
			justify-content: center;

            &:deep(svg) {
				width: 20px;
				height: 20px;

				.fill {
					fill: var(--theme-txt2-color);
				}

                .stroke {
					stroke: var(--theme-txt2-color);
				}
			}
		}

        .title {
            font-size: var(--font-size-l);
            font-weight: 500;
            color: var(--theme-txt2-color);
        }
    }
}
</style>